<template>
  <section>
    <!--工具条-->
    <StatisticsCentreToolbar :buttonList="buttonList" @callFunction="callFunction" ref="child"></StatisticsCentreToolbar>

    <!--列表-->
    <el-table
      :data="statisticsCentreList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      style="width: 100%;"
    >
      <el-table-column type="index" label="序号" width="100"></el-table-column>
      <el-table-column
          label="操作"
          width="90">
          <template slot-scope="scope">
            <span v-for="item in operationButtonList" :key="item.id">
              <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && item.name === '操作日记'" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
            </span>
          </template>
      </el-table-column>
      <el-table-column prop="DepartureDate" label="出车日期" :formatter="formatDepartureDate" width="120"></el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="120"></el-table-column>
      <el-table-column prop="LicensePlateNumber" label="车牌号" width="150"></el-table-column>
      <el-table-column prop="ShiftName" label="班次" width="120"></el-table-column>
      <el-table-column prop="DriverName" label="司机" width="120"></el-table-column>
      <el-table-column prop="DepartureTimeStr" label="计划出车时间" width="120"></el-table-column>
      <el-table-column prop="ActualDepartureTimeStr" label="实际出车时间" width="120"></el-table-column>
      <el-table-column prop="TimeDifference" label="发车时差(分)" width="120"></el-table-column>
      <el-table-column prop="StateName" label="状态" width="150"></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="TwoTableOperateDataLogFormVisible"
      v-model="TwoTableOperateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <TwoTableOperateDataLog v-if="TwoTableOperateDataLogFormVisible" :oneEntityName="oneEntityName" :oneEntityKey="oneEntityKey" :twoEntityName="twoEntityName" :twoEntityKey="twoEntityKey"></TwoTableOperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="TwoTableOperateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getStatisticsCentreListPage,exportStatisticsCentre } from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import StatisticsCentreToolbar from "../../components/QueryToolbar/StatisticsCentreToolbar";
import TwoTableOperateDataLog from "../../components/TwoTableOperateDataLog";

export default {
  components: { StatisticsCentreToolbar ,TwoTableOperateDataLog},
  data() {
    return {
      filters: {
        busLinesId:"", //线路ID
        driverId:"", //驾驶员Id
        vehicleId:"", //驾驶员Id
        departureDate: [] //出车时间
      },
      oneEntityName: '', //操作日记中的第一张表名称
      oneEntityKey: '', //操作日记中的第一张表的Id
      twoEntityName:'',//操作日记中的第二张表名称
      twoEntityKey:'',//操作日记中的第二张表的Id
      buttonList: [],
      operationButtonList: [],
      statisticsCentreList: [], //统计中心列表
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      TwoTableOperateDataLogFormVisible: false, //查看操作日记界面是否显示
      sels: [], //列表选中列
      currentRow: null,
      multipleSelection: []
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        busLinesId: item.busLinesId,
        driverId: item.driverId,
        vehicleId: item.vehicleId,
        departureDate: (item.departureDate !== null && item.departureDate.length>0)?item.departureDate.toString():""
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getStatisticsCentre();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getStatisticsCentre();
    },
    queryStatisticsCentre(){
      this.page = 1;
      this.getStatisticsCentre();
      //this.$emit('myevent',null);
    },
    formatDepartureDate: function(row, column) {
      return !row.DepartureDate || row.DepartureDate == ""
        ? ""
        : util.formatDate.format(new Date(row.DepartureDate), "yyyy-MM-dd");
    },
    //获取统计中心列表
    getStatisticsCentre() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        vehicleId: _this.filters.vehicleId,
        driverId: _this.filters.driverId,
        departureDate: _this.filters.departureDate,
        taskState: '',
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getStatisticsCentreListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.statisticsCentreList = res.data.response.data;
        _this.listLoading = false;
      });
    },
     //查看操作日记
     lookUpOperateDataLog() {
      
      this.TwoTableOperateDataLogFormVisible = true;
      this.oneEntityName= 'RunCenterTask';
      this.twoEntityName="Scheduling";
      this.oneEntityKey =  this.currentRow.RunCenterTaskId;
      this.twoEntityKey=this.currentRow.SchedulingId;
      
    },
    // 获取导出文件名称
    getFileName(){
      let _this = this;
      let fileName = "统计中心";
      if(_this.filters.departureDate !== null && _this.filters.departureDate.length>0){
        let departureDateArr = _this.filters.departureDate.split(",");
        fileName += departureDateArr[0] +'至'+ departureDateArr[1];
      }

      return fileName + '全部数据';
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //导出统计中心数据
    handleExportStatisticsCentre() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        vehicleId: _this.filters.vehicleId,
        driverId: _this.filters.driverId,
        departureDate: _this.filters.departureDate,
        taskState: ''
      };
      exportStatisticsCentre(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        let fileName = _this.getFileName();
        a.download = fileName+".xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
      (err) => {
        resolve(err.response);
      })
      .catch((error) => {
        Promise.reject(error);
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.getStatisticsCentre();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
